import { render } from "./FavCardMatch.vue?vue&type=template&id=1240505c&scoped=true"
import script from "./FavCardMatch.vue?vue&type=script&lang=js"
export * from "./FavCardMatch.vue?vue&type=script&lang=js"

import "./FavCardMatch.vue?vue&type=style&index=0&id=1240505c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1240505c"]])

export default __exports__